import { Box, Checkbox, Stack, Tooltip } from '@mui/material';
import type { BackupPolicyConfig } from '@repo/api-gw-sdk';

import { BackupPolicyTag } from '@/components/backupPolicy/BackupPolicyTag';

export const BackupPoliciesSelector = ({
  backupPolicies,
  selectedPolicies,
  setSelectedPolicies,
  showDisabledPolicies = false,
  selectionDisabledPolicies,
  disabledTooltip,
}: {
  backupPolicies: BackupPolicyConfig[];
  selectedPolicies: BackupPolicyConfig[];
  setSelectedPolicies: (policies: BackupPolicyConfig[]) => void;
  showDisabledPolicies?: boolean;
  selectionDisabledPolicies?: Set<string>;
  disabledTooltip?: string;
}) => {
  return (
    <Box
      className='px-[40px]'
      sx={{
        maxHeight: '300px',
        overflow: 'auto',
      }}
    >
      {backupPolicies
        .filter((policy) => showDisabledPolicies || policy.enabled)
        .sort((a) => (a.enabled ? -1 : 1))
        .map((policy) => {
          const isDisabled = selectionDisabledPolicies?.has(policy.id) ?? false;
          return (
            <Stack
              direction='row'
              alignItems='center'
              key={policy.id}
              gap='8px'
              sx={{ py: '4px' }}
            >
              <Tooltip title={isDisabled ? disabledTooltip : ''}>
                <span>
                  <Checkbox
                    value={policy.id}
                    checked={selectedPolicies.some((p) => p.id === policy.id)}
                    disabled={isDisabled}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedPolicies([...selectedPolicies, policy]);
                      } else {
                        setSelectedPolicies(
                          selectedPolicies.filter((p) => p.id !== policy.id)
                        );
                      }
                    }}
                  />
                </span>
              </Tooltip>
              <BackupPolicyTag policy={policy} />
            </Stack>
          );
        })}
    </Box>
  );
};
